/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ContractDetailsDtoApiResponse } from '../../models/contract-details-dto-api-response';

export interface DeleteBankAsync$Plain$Params {
  id: number;
  bankId: number;
}

export function deleteBankAsync$Plain(http: HttpClient, rootUrl: string, params: DeleteBankAsync$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<ContractDetailsDtoApiResponse>> {
  const rb = new RequestBuilder(rootUrl, deleteBankAsync$Plain.PATH, 'delete');
  if (params) {
    rb.path('id', params.id, {});
    rb.path('bankId', params.bankId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ContractDetailsDtoApiResponse>;
    })
  );
}

deleteBankAsync$Plain.PATH = '/api/customer/{id}/bank/{bankId}';
